module.exports = __webpack_public_path__ + "static/media/icon.0ff01f0e.png";